import Super from './show';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNext extends Super {
  templateName = 'site/documents/show';
}
